import { render, staticRenderFns } from "./YellowModal.vue?vue&type=template&id=71e1c202&scoped=true"
import script from "./YellowModal.vue?vue&type=script&lang=js"
export * from "./YellowModal.vue?vue&type=script&lang=js"
import style0 from "./YellowModal.vue?vue&type=style&index=0&id=71e1c202&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e1c202",
  null
  
)

export default component.exports